import { AuditableBaseDto, LocalizedProperty } from "../common";
import { MediaDto } from "../media";
import { QuestionDto } from "../question";

export interface SkillDto extends AuditableBaseDto {
  name: LocalizedProperty;
  content: LocalizedProperty;
  video?: MediaDto;
  state?: SkillType;
  questions?: QuestionDto[];
}

export enum SkillType {
  CREATED_MANUALLY = "created_manually",
  AI_SUGGESTED = "ai_suggested",
  CHOSEN_FROM_DROPDOWN = "chosen_from_dropdown",
}
